import { render, staticRenderFns } from "./ContactsFilter.vue?vue&type=template&id=2fb6935e&scoped=true&"
import script from "./ContactsFilter.vue?vue&type=script&lang=js&"
export * from "./ContactsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6935e",
  null
  
)

export default component.exports